export const environment = {
  production: false,
  demo: true,
  dev: false,
  // apiUrl: null,
};
